import React from 'react';
import { useTheme } from '../../hooks/useTheme';
import './SidebarHeader.css';

function SidebarHeader({ onToggleSidebar, isSidebarCollapsed = false }) {
  const { theme, toggleTheme } = useTheme();

  return (
    <div className="sidebar-header">
      <div className="sidebar-brand">
        <span className="brand-icon">K</span>
        <span className="brand-name">Kapsa AI</span>
      </div>
      <div className="sidebar-header-actions">
        <button
          type="button"
          className="theme-toggle-btn"
          onClick={toggleTheme}
          aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
          title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
        >
          {theme === 'dark' ? (
            <svg viewBox="0 0 20 20" width="16" height="16" fill="currentColor">
              <path d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z" />
            </svg>
          ) : (
            <svg viewBox="0 0 20 20" width="16" height="16" fill="currentColor">
              <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" />
            </svg>
          )}
        </button>
        <button
          type="button"
          className="sidebar-compose-btn"
          title="New conversation"
          aria-label="New conversation"
        >
          +
        </button>
        {typeof onToggleSidebar === 'function' && (
          <button
            type="button"
            className="sidebar-collapse-btn"
            onClick={onToggleSidebar}
            aria-controls="workspace-sidebar"
            aria-expanded={!isSidebarCollapsed}
            aria-label={isSidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
            title={isSidebarCollapsed ? 'Show sidebar' : 'Hide sidebar'}
          >
            <svg viewBox="0 0 16 16" width="14" height="14" fill="currentColor" aria-hidden="true">
              <path d="M9.354 4.646a.5.5 0 010 .708L6.707 8l2.647 2.646a.5.5 0 01-.708.708l-3-3a.5.5 0 010-.708l3-3a.5.5 0 01.708 0z" />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
}

export default SidebarHeader;
